import { EPageMenuType, EPageSubmenuType } from '@hts/shared/enums';
import { IGetStaticElementsResponse, IPageDepartmentSectionEntry } from '@hts/shared/types';
import { HtsTypography, HtslIcon } from '@hts/shared/ui';
import { DateTime } from 'luxon';
import { memo, useMemo } from 'react';
import { Link } from 'react-router-dom';
import styles from '../../styles/Footer/Footer.module.scss';
import { MainContent } from './MainContent';

interface FooterProps {
  data?: IGetStaticElementsResponse;
  pageDepartment: IPageDepartmentSectionEntry | null;
}

export const Footer: React.FC<FooterProps> = memo(({ data, pageDepartment }) => {
  const menus = data?.menus;

  const { simchasCategories, occasionsCategories } = useMemo(() => {
    const footerMenu = menus?.find((menu) => menu.type === EPageMenuType.FOOTER_MENU);

    const simchasCategories = footerMenu?.submenus?.find(
      ({ type }) => type === EPageSubmenuType.SIMCHAS
    )?.categories;

    const occasionsCategories = footerMenu?.submenus?.find(
      ({ type }) => type === EPageSubmenuType.OCCASIONS
    )?.categories;

    return { simchasCategories, occasionsCategories };
  }, [menus]);

  return (
    <footer className={styles.container}>
      <div className={styles.centerMainContainer}>
        <MainContent
          simchasCategories={simchasCategories}
          occasionsCategories={occasionsCategories}
          pageDepartment={pageDepartment}
        />
      </div>

      <div className={styles.centerBottomContainer}>
        <div className={styles.bottomContainer}>
          <div className={styles.socialNetworkContainer}>
            <Link to="https://wa.me/17186125052" target="_blank">
              <HtslIcon icon="whatsapp" color="white" />
            </Link>

            <Link to="https://www.instagram.com/ihopetoseeyou_com/" target="_blank">
              <HtslIcon icon="instagram" color="white" />
            </Link>

            <Link to="https://www.linkedin.com/in/peri-eiger-673117280/" target="_blank">
              <HtslIcon icon="linkedin" color="white" />
            </Link>
          </div>

          <div className={styles.paymentSystemsContainer}>
            <HtslIcon icon="visa" color="white" className={styles.paymentIcon} />
            <HtslIcon icon="master-card" color="white" className={styles.paymentIcon} />
            <HtslIcon icon="american-express" color="white" className={styles.paymentIcon} />
            <HtslIcon icon="discover" color="white" className={styles.paymentIcon} />
          </div>

          <div className={styles.copyrightContainer}>
            <HtsTypography variant="caption" color="white">
              © {DateTime.now().year} ihopetoseeyou.com | Powered by {''}
              <a href="https://podium.nyc" target="_blank" rel="noreferrer">
                podium.nyc
              </a>
            </HtsTypography>
          </div>
        </div>
      </div>
    </footer>
  );
});
